const getDefaultLocaldata = (): AppLocaldata => ({
  menuCollapsed: false,
  displayedMarketOnSchedule: 'winner'
});

export { getDefaultLocaldata };
